import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DsLibMainMenuTab } from '../../models/ds-lib-main-menu-tab.model';
import { DsLibMainMenuSectionInterface } from '../../interfaces/ds-lib-main-menu-section.interface';
import { DsLibMainMenuSection } from '../../models/ds-lib-main-menu-section.model';
import { DsLibMainMenuRouterLinkArgs } from '../../interfaces/ds-lib-main-menu-router-link-args.interface';

@Component({
  selector: 'ds-lib-section',
  templateUrl: './ds-lib-section.component.html',
  styleUrls: ['./ds-lib-section.component.scss'],
})
export class DsLibSectionComponent {
  /**
   * Is the menu expanded
   */
  @Input() isExpanded: boolean;

  /**
   * A menu tab instance of the `DsLibMainMenuTab`
   */
  @Input() tab: DsLibMainMenuTab;

  /**
   * The disconnect button title font size
   */
  @Input() fontSize: string;

  /**
   * List of all user rights
   */
  @Input() rights: number[];

  /**
   * The section click event emiter
   */
  @Output() sectionClicked = new EventEmitter<DsLibMainMenuSectionInterface>();

  /**
   * @param section the menu section tab example 'GED'
   */
  public onSectionClick(section: DsLibMainMenuSectionInterface) {
    this.sectionClicked.emit(section);
  }

  /**
   * It returns an object with the id of the selected item in the tab, and the args of the section.
   *
   * @param section this is the section that is being clicked on.
   * @returns The id of the selected item and the args of the section.
   */
  public getArgs(section: DsLibMainMenuSection): DsLibMainMenuRouterLinkArgs {
    return { id: this.tab.selectedItem?.id, ...section.args };
  }
}
